"use strict";
var elementResizeDetectorMaker = require('element-resize-detector');
var browserDetector = require('element-resize-detector/src/browser-detector');
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    defineContainer: function (element) {
        var _this = this;
        if (element) {
            if (!this.$erd) {
                this.$erd = elementResizeDetectorMaker(browserDetector.isIE(9) ? null : { strategy: 'scroll' });
            }
            if (this.$container) {
                this.$erd.removeAllListeners(this.$container);
            }
            this.$container = element;
            this.$erd.listenTo(this.$container, function (element) {
                if (_this.componentDidResize) {
                    _this.componentDidResize(element);
                }
            });
        }
        else {
            if (this.$erd) {
                this.$erd.uninstall(this.$container);
            }
            this.$container = null;
            this.$erd = null;
        }
    },
};
//# sourceMappingURL=ResizeDetectorMixin.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-container-query/lib/ResizeDetectorMixin.js
 ** module id = 420
 ** module chunks = 0
 **/